import './MenuTop.scss';
import React from 'react';
import Link from 'Components/Shared/Link/Link';
import MenuUserContainer from 'Components/MenuUser/MenuUserContainer';

export interface IMenuItem {
  displayName: string,
  formattedName: string,
  iconType?: string;
  localPath?: string;
  backgroundColor?: string;
}

interface IProps {
  isMobile: boolean;
  isCustomerMenuVisible: boolean;
  buttonContact: IMenuItem;
  buttonOrganizer: IMenuItem;
  buttonVoucher: IMenuItem;
  buttonMyPage: IMenuItem;
  onMyPageClick: () => void;
  onCloseCustomerMenu: () => void;
}

const MenuTop: React.SFC<IProps> = ({ 
  isMobile,
  isCustomerMenuVisible,
  buttonContact,
  buttonOrganizer,
  buttonVoucher,
  buttonMyPage,
  onMyPageClick,
  onCloseCustomerMenu,
}) => (
  <div className={ isMobile ? 'menu-top-mobile' : 'menu-top' }>
    <Link style={ `item bg-${ buttonContact.backgroundColor }` } { ...buttonContact } />
    { !isMobile && <Link style={ `item bg-${ buttonOrganizer.backgroundColor }` } { ...buttonOrganizer } /> }
    <Link style={ `item bg-${ buttonVoucher.backgroundColor }` } { ...buttonVoucher } />
    <Link style={ `item bg-${ buttonMyPage.backgroundColor }` } { ...buttonMyPage } onClick={ onMyPageClick } />
    <MenuUserContainer { ... { isVisible: isCustomerMenuVisible, onClose: onCloseCustomerMenu } } />
  </div>
);

export default MenuTop;


// WEBPACK FOOTER //
// ./src/components/MenuTop/MenuTop.tsx